// Moved to @hyperframes/parsers/slideshow. Re-exported here for back-compat.
export * from "@hyperframes/parsers/slideshow";
